import { stringifyEntityRef } from '@backstage/catalog-model';
import { CatalogGraphPage } from '@backstage/plugin-catalog-graph';
import { useEntity } from '@backstage/plugin-catalog-react';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { Icon } from '@iconify/react';
import { isDataProductEntity } from '@ipen-portal/ipen-entity-model';
import { useMemo } from 'react';
import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  graphContainer: {
    '& header': {
      display: 'none !important',
    },
  },
}));

const DataProductCatalogGraphPage = () => {
  const { classes } = useStyles();
  const { entity } = useEntity();

  const initialState = useMemo(
    () => ({
      maxDepth: 1,
      rootEntityRefs: [stringifyEntityRef(entity)],
    }),
    [entity],
  );

  return (
    <section aria-label="Catalog Graph Page" className={classes.graphContainer}>
      <CatalogGraphPage initialState={initialState} />
    </section>
  );
};

export const DataProductEntityContent = EntityContentBlueprint.make({
  name: 'DataProductEntityContent',
  params: {
    filter: isDataProductEntity,
    icon: <Icon icon="carbon:property-relationship" />,
    loader: async () => <DataProductCatalogGraphPage />,
    path: '/entity-graph',
    title: 'Entity Graph',
  },
});
